import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Container } from '../../components/Layout';

const ListContainer = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: stretch;
  flex-wrap: wrap;
  max-width: var(--content-width);
  margin: 0 auto;
  > li {
    position: relative;
    overflow: hidden;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 50%;
  }
`;
const ListItem = styled.div`
  position: relative;
  padding: var(--size-space-medium);
  //border: 1px solid var(--color-level-1);
  h1,
  h2,
  h3,
  h4,
  h5 {
    color: var(--color-primary-light);
  }
  .blockHeading,
  .blockContent {
    position: relative;
    z-index: 3;
  }
  .blockNumber {
    font-size: 8rem;
    line-height: 1em;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    opacity: 0.24;
    font-weight: var(--font-weight-bold);
    color: var(--color-primary-light);
  }
`;

const SliceStepList = ({ input }) => {
  //console.log(input);

  const items = input.items.map(
    ({ heading, rich_text, step, thumbnail }, index) => (
      <Container as="li" key={step + index} isRichText>
        <ListItem key={index + 1}>
          <div
            className="blockHeading"
            dangerouslySetInnerHTML={{ __html: heading.html }}
          />
          <div
            className="blockContent"
            dangerouslySetInnerHTML={{ __html: rich_text.html }}
          />

          <h6 className="blockNumber">{step}</h6>
        </ListItem>
      </Container>
    )
  );

  return <ListContainer>{items}</ListContainer>;
};

export default SliceStepList;

SliceStepList.propTypes = {
  input: PropTypes.object.isRequired,
};

/*




*/
